// i18n area 'apps' — locale sk-SK (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/apps.sk-SK.meta.json.
import type { enUS } from './apps'

export const skSK: typeof enUS = {

  // Apps wave 1 (Annex R): container podman gestiti — supervisionati dal
  // worker su un nodo dichiarato; immagine = lockfile branch@digest (Annex Q)
  // con policy pinned/tracking; attacco L3 untagged con IP statico.
  apps: {
    title: 'Aplikácie',
    create: 'Vytvoriť aplikáciu',
    createTitle: 'Vytvoriť aplikáciu',
    editTitle: 'Upraviť aplikáciu',
    name: 'Názov',
    nameHint: 'DNS-1123, jedinečný v scope — po vytvorení nemenný.',
    node: 'Uzol',
    nodeHint: 'Členský uzol, ktorý ju obsluhuje — explicitné umiestnenie (plánovač príde neskôr).',
    image: 'Obraz',
    editImageHint: 'Nová referencia sa znovu rezolvuje cez evidenciu — gesto pinu/rollbacku.',
    imagePolicy: 'Policy',
    policyPinned: 'pinned',
    policyTracking: 'tracking',
    policyPinnedHint: 'Digest sa hýbe len na príkaz.',
    policyTrackingHint: 'Automatický rolling, keď aktualizácia posunie branch.',
    archMovePolicy: 'Presun cross-arch',
    archMoveRefuse: 'refuse',
    archMoveReresolve: 'reresolve',
    archMovePolicyHint: 'Čo sa stane, keď sa app presunie na node inej architektúry: refuse presun odmietne, reresolve znovu vyrieši lockfile z branchu na novej arch — obsah sa zmení a odpoveď pomenuje zmenu digestu.',
    network: 'Sieť',
    networkHint: 'Pripojenie L3 untagged: logická sieť fabric (odporúčaná — brána/DNS z jej jediného zdroja), overlay, alebo holý hostiteľský bridge (neodporúčané).',
    overlayPrefix: 'overlay:',
    fabricPrefix: 'fabric:',
    bridgePrefix: 'host bridge:',
    ipAssignment: 'Priradenie IP',
    ipStatic: 'Statické',
    ipAuto: 'Automatické (IPAM)',
    ipAssignmentHint_static: 'Adresu zadáte vy, teraz.',
    ipAssignmentHint_auto: 'IPAM vyberie voľnú adresu z rozsahov siete rezervovaných pre TVirt.',
    bridgeDiscouraged: 'Holý hostiteľský bridge — NEODPORÚČANÉ: TVirt nevie nič o jeho adresovaní, takže bránu a DNS treba zadať ručne. Odporúčaná cesta je logická sieť fabric.',
    ip: 'IP',
    ipHint: 'Statická IPv4 vo vnútri podsiete pripojenia.',
    ipCidrHint: 'Vo forme CIDR na holom bridge (napr. 192.168.1.10/24) — niet z čoho odvodiť prefix.',
    gateway: 'Brána',
    gatewayManualHint: 'Ručne — holý bridge nič neodvodzuje.',
    dnsServers: 'Servery DNS',
    dnsManualHint: 'Ručne, oddelené čiarkou — aspoň jeden.',
    rootKind: 'Root',
    rootEphemeral: 'efemérna',
    rootPersistent: 'perzistentná',
    rootEphemeralHint: 'Znovu vytvorená z obrazu pri každom novom vytvorení; žije na efemérnom úložisku klastra.',
    rootEphemeralHintNamed: 'Znovu vytvorená z obrazu pri každom novom vytvorení; žije na efemérnom úložisku klastra ({name}).',
    rootPersistentHint: 'Prežíva reštarty; žije na úložisku, ktoré si vyberiete.',
    rootStorage: 'Úložisko pre root',
    editRootStorageHint: 'Root sa znovu vykreslí na novom poole — existujúce dáta sa NEPRESUNÚ samy.',
    volumes: 'Zväzky',
    volumeAdd: 'Pridať zväzok',
    volumeName: 'Názov',
    volumeMountPath: 'Cesta pripojenia',
    volumeKind: 'Typ',
    volumeStorage: 'Úložisko',
    devices: 'Zariadenia',
    deviceClassHint: 'Žiada sa TRIEDA (tag gpu-device alebo usb-device), nikdy konkrétne zariadenie: deklarovaný uzol musí mať nejaké označené pre Apps. Viacero Apps môže používať to isté zariadenie — kontajner ho zdieľa, neberie ho hostiteľovi.',
    deviceSlot: 'Slot',
    deviceTag: 'Tag',
    deviceValue: 'Trieda',
    deviceUnresolved: 'teraz sa nič nerieši',
    noDeviceTags: 'Zatiaľ žiadny tag druhu gpu-device alebo usb-device: vytvorte ho a priraďte zariadeniam označeným pre Apps.',
    env: 'Prostredie',
    envHint: 'Jeden KĽÚČ=hodnota na riadok.',
    secretEnvTitle: 'Tajné premenné',
    secretEnvNotice: 'Tajná hodnota sa už nikdy nevráti z API: nikto si ju znovu neprečíta, ani ten, kto ju zapísal. V checkpointe cestuje zapečatená pomocou masterpass, takže obnovenie bez masterpass si ju vyžiada znovu.',
    secretEnvPromote: 'Označte ako tajnú jednu z premenných zapísaných vyššie:',
    secretEnvAdd: 'Pridať tajnú premennú',
    secretEnvName: 'Názov',
    secretEnvValue: 'Hodnota',
    secretEnvKept: 'zachovaná — nechajte prázdne, aby ostala nezmenená',
    secretEnvWithdrawWarning: 'Ak chcete prestať zaobchádzať ako s tajnou s premennou, ktorá už tajná je, zapíšte jej novú hodnotu: samotné odobratie značky by bol spôsob, ako PREČÍTAŤ to, čo zo store nikdy nevychádza. Jej odstránenie ju naopak vymaže.',
    secretEnvChip: 'tajné',
    startNow: 'Spustiť hneď (inak sa aplikácia narodí zastavená)',
    deletePersistentIntro: 'Táto aplikácia má perzistentné dáta — vyberte, čo s nimi:',
    deleteKeepData: 'Ponechať dáta (adresáre zostanú na svojich úložiskách ako osirotené)',
    deletePurgeData: 'Odstrániť aj dáta',
    phase: 'Fáza',
    phase_running: 'Beží',
    phase_stopped: 'Zastavená',
    phase_error: 'Chyba',
    phase_unknown: 'Neznáma',
    desiredState: 'Žiadaný stav',
    wantedRunning: 'beží',
    wantedStopped: 'zastavená',
    start: 'Spustiť',
    stop: 'Zastaviť',
    restart: 'Reštartovať',
    refreshImage: 'Aktualizovať obraz (prevziať nový @current)',
    logs: 'Logy',
    logsTitle: 'Logy',
    logsEmpty: 'Žiadny zachytený výstup.',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'App nebeží — shell potrebuje živý kontajner. Jej logy sa dajú čítať v akomkoľvek stave.',
    shellConnect: 'Pripojiť',
    shellDisconnect: 'Odpojiť',
    shellExited: 'Relácia skončila s návratovým kódom {code}.',
    shellEndedWithoutStatus: 'Relácia skončila bez návratového stavu: {reason}',
    shellRevoked: 'Ticket relácie už nie je platný — vypršal, alebo prihlásenie, ktoré ho otvorilo, bolo odvolané.',
    shellHint: 'Kliknite do čierneho poľa a píšte: klávesy idú do kontajnera. Ctrl+C a šípky fungujú; exit shell zavrie.',
    shellStatus: {
      connecting: 'Pripája sa…',
      connected: 'Pripojená',
      ended: 'Ukončená'
    },
    deleteRunningError: '{name} je žiadaná v behu — najprv ju zastavte.',

    // Dialog standard (round #156): i tab del dettaglio e i campi contract
    // mancanti — ogni campo dell'App visibile, lucchetti col perché.
    tabs: {
      general: 'Všeobecné',
      image: 'Obraz',
      network: 'Sieť',
      storage: 'Úložisko',
      devices: 'Zariadenia',
      observed: 'Pozorované'
    },
    attachment: 'Pripojenie',
    runningDigest: 'Bežiaci digest',
    lastError: 'Posledná chyba',
    reportObservedAt: 'Posledný report workera',
    desiredStateLock: 'Riadia ho akcie Spustiť/Zastaviť — nikdy priama úprava.',
    ipEditDisabledHint: 'Upraviteľné len pri statickom priraďovaní.',
    derivedFromNetworkHint: 'Odvodené z jediného zdroja siete — ručne len na holom bridge so statickou IP.',
    ephemeralUnset: 'nenakonfigurované',
    ephemeralMissing: 'Efemérne úložisko aplikácií nie je nakonfigurované — vytvorenie aplikácie s efemérnymi časťami (root alebo zväzky) sa odmieta, kým ho nenastavíte.',
    ephemeralCurrent: 'Efemérne úložisko aplikácií: {name}',
    ephemeralMissingCreate: 'Táto aplikácia má efemérne časti, ale efemérne úložisko aplikácií nie je nastavené — vytvorenie bude odmietnuté. Najprv ho nastavte z bannera stránky Aplikácie.',
    setEphemeral: 'Nastaviť efemérne úložisko',
    changeEphemeral: 'Zmeniť efemérne úložisko',
    setEphemeralTitle: 'Nastaviť efemérne úložisko aplikácií',
    changeEphemeralTitle: 'Zmeniť efemérne úložisko aplikácií',
    ephemeralStorageHint: 'PREDVOLENÉ pre klaster: pool typu dir, kde žijú rooty a efemérne zväzky každej aplikácie, pokiaľ aplikácia nedeklaruje vlastný override. Zmena sa nedeje za horúca a nič nereštartuje: platí od najbližšieho štartu každej aplikácie — efemérne dáta sa nepresúvajú.',
    ephemeralPool: 'Pool úložiska',
    ephemeralOverride: 'Efemérne úložisko (override pre aplikáciu)',
    ephemeralOverrideInherit: 'Zdediť predvolené z klastra',
    ephemeralOverrideInheritNamed: 'Zdediť predvolené z klastra ({name})',
    ephemeralOverrideHint: 'Pool pre root a efemérne zväzky konkrétnej aplikácie — nechajte prázdne pre zdedenie predvoleného z klastra. Zmena sa nedeje za horúca a nič nereštartuje: platí od najbližšieho štartu (efemérne dáta sa znovuzrodia prázdne na novom poole) a vyžaduje oprávnenie app.ephemeralStorage.set.',
    ephemeralOverrideTag: 'override',

    imageAnyBranch: 'Všetky vetvy',
    imageBranchHint: 'Zúži obrazy na tie, ktoré pomenúva táto vetva; bez vetvy vidno všetky obrazy repozitára.',
    imageDigestHint: 'Obsah: vyberá sa z tabuľky digestov, ktorá nesie jeho pôvod a architektúru. Tá istá vetva ponúka po jednom na architektúru a nie sú zameniteľné.',
    imageLockfile: 'Vyriešená referencia',
    imageNoImages: 'Pre tento repozitár nie sú v cache žiadne obrazy — stiahni jeden z Obrazov OCI.',
    imageHeadNotCached: 'nie je v cache — stiahne sa pri štarte',
    imageNoRegistries: 'Nie je registrovaný žiadny repozitár: zaregistruj jeden, aby sa dal vybrať obraz.',
    imageChosenHint: 'Obraz sa vyberá kaskádou v dialógu úprav: referencia sa nikdy nepíše ručne.',
    registerRepositoryHint: 'Registrácia nič nesťahuje: urobí repozitár sledovateľným, aby sa obraz dal vybrať bez opustenia tohto dialógu.',
    registerRepositoryBranchHint: 'Voliteľné: prvá sledovaná vetva (napr. latest).',
    registerRepositoryElsewhere: 'Hľadaný repozitár nie je registrovaný: registrácia prebieha v sekcii Obrazy OCI, vykonáva ju ten, kto má oprávnenie.'
  },

  // Template CT (round K2 #63): gli oggetti CT MATERIALIZZATI — l'import da
  // catalogo è l'unico ingresso; i file si caricano dentro i cataloghi.
  cts: {
    createAction: 'Vytvoriť CT',
    createTitle: 'Vytvoriť kontajner zo šablóny',
    createError: 'Kontajner nebol vytvorený',
    template: 'Šablóna CT',
    noTemplates: 'Žiadna šablóna CT — importujte jednu zo Šablón CT',
    resources: 'Zdroje',
    node: 'Uzol',
    phase: {
      defined: 'Nikdy nezapnutý',
      materializing: 'Materializuje sa',
      ready: 'Pripravený',
      starting: 'Spúšťa sa',
      running: 'Beží',
      stopping: 'Zastavuje sa',
      stopped: 'Zastavený',
      deleting: 'Odstraňuje sa',
      error: 'V chybovom stave'
    },
    actions: {
      start: 'Spustiť',
      stop: 'Zastaviť',
      restart: 'Reštartovať',
      markTemplate: 'Povýšiť na šablónu CT',
      error: 'Akcia bola odmietnutá'
    },
    markTemplate: {
      confirmTitle: 'Povýšiť „{name}“ na šablónu CT?',
      confirmBody: 'Kontajner opustí tento zoznam a prejde medzi Šablóny CT, hneď pripravený generovať nové CT. Metadáta zostávajú upraviteľné a kedykoľvek ho môžete vrátiť na CT.',
      confirm: 'Povýšiť',
      moved: '„{name}“ je teraz šablóna CT — nájdete ho medzi Šablónami CT.'
    },
    stopCause: {
      api: 'Zastavil ho TVirt',
      'ct-exit': 'Kontajner sa ukončil sám',
      'host-reboot': 'Zomrel s reštartom uzla',
      'start-failed': 'Spustenie zlyhalo — chyba úlohy hovorí, čo chýba a ako to napraviť'
    },

    console: 'Konzola',
    consoleUnavailable: 'Kontajner nebeží — konzola potrebuje živý kontajner. Jeho logy sa naproti tomu čítajú v akomkoľvek stave.',
    consoleNoTemplate: 'Šablóna nikdy nebeží, takže nemá konzolu: vytvorte z nej CT a otvorte konzolu jeho.',
    consoleConnect: 'Pripojiť',
    consoleDisconnect: 'Odpojiť',
    consoleReconnect: 'Znova pripojiť',
    consoleTakenBy: 'Túto konzolu prevzal iný operátor ({user}). Jedna konzola na kontajner: opätovné pripojenie ju vezme späť.',
    consoleHint: 'Kliknite na čierne pole a píšte: klávesy sa dostanú do kontajnera. Ctrl+C a šípky fungujú.',
    consoleEndpointDown: 'Prístupový bod konzoly sa nedá otvoriť na uzle, ktorý kontajner obsluhuje: {cause}',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'Kontajner nebeží — shell potrebuje živý kontajner. Jeho logy sa dajú čítať v akomkoľvek stave.',
    shellNoTemplate: 'Template nikdy nebeží, takže nemá shell: vytvorte z neho CT a otvorte jeho.',
    shellConnect: 'Pripojiť',
    shellDisconnect: 'Odpojiť',
    shellExited: 'Relácia skončila s návratovým kódom {code}.',
    shellEndedWithoutStatus: 'Relácia skončila bez návratového stavu: {reason}',
    shellRevoked: 'Ticket relácie už nie je platný — vypršal, alebo prihlásenie, ktoré ho otvorilo, bolo odvolané.',
    shellHint: 'Kliknite do čierneho poľa a píšte: klávesy idú do kontajnera. Ctrl+C a šípky fungujú; exit shell zavrie.',
    shellStatus: {
      connecting: 'Pripája sa…',
      connected: 'Pripojená',
      ended: 'Ukončená'
    },
    rootPassword: 'Heslo roota',
    rootPasswordHint: 'Zapíše sa raz do skopírovaného rootfs (ako hash, už sa nikdy nezobrazí). Obrazy distribúcií nemajú heslo roota: bez neho je shell jediná cesta dnu.',
    sshKeys: 'Verejné SSH kľúče roota',
    sshKeysHint: 'Jeden verejný kľúč OpenSSH na riadok, do root/.ssh/authorized_keys.',
    consoleStatus: {
      connecting: 'Pripája sa…',
      connected: 'Pripojené',
      reconnecting: 'Znova sa pripája…'
    },
    logs: 'Logy',
    logsTitle: 'Logy',
    logsEmpty: 'Žiadny zachytený výstup.',
    logsSource: 'Ktorý log',
    logsSourceConsole: 'Konzola initu kontajnera — prečo sa služba vnútri nespustila',
    logsSourceSupervisor: 'Supervízor liblxc — prečo sa kontajner nikdy nedostal až k behu',
    logsNeverStarted: 'Nikdy nebol spustený, takže zatiaľ nie je nič zaznamenané — spustite ho a logy tam budú, aj keď spustenie zlyhá.',
    logsNoTemplate: 'Šablóna nikdy nebeží, takže nikdy nič nezaznamenala.',
    logsError: 'Logy sa nepodarilo zachytiť',

    // Dialog standard (round #156): i tab del dettaglio condivisi dalle
    // liste CT e Template CT, più i lucchetti col perché.
    tabs: {
      general: 'Všeobecné',
      hardware: 'Hardvér',
      network: 'Sieť',
      provenance: 'Pôvod'
    },
    templateFlag: 'Šablóna CT',
    templateLock: 'Mení sa len akciami Povýšiť / Vrátiť na CT — nikdy priamou úpravou.',
    sourceLock: 'Pôvod, zaznamenaný pri vzniku — nikdy sa neprepisuje; mŕtvy zdroj necháva holú referenciu.',
    storageLock: 'Pevné od vytvorenia — presun rootfs je budúci round.',
    startedAt: 'Spustený',
    lastStop: 'Posledné zastavenie',
    editNicsTitle: 'Upraviť siete',
    nicDisconnected: 'odpojená'
  },
  ctTemplates: {
    title: 'Šablóny CT',
    importAction: 'Importovať z katalógu',
    importTitle: 'Importovať šablónu CT z katalógu',
    importSubmit: 'Importovať',
    importError: 'Import bol odmietnutý',
    importHint: 'Materializácia kopíruje rootfs na zvolené úložisko — súbor v katalógu zostáva nedotknutý. Nové súbory najprv nahrajte do niektorého katalógu.',
    sourceFile: 'Súbor šablóny CT',
    sourceFileHint: 'Súbory ct-rootfs zvoleného katalógu, len tie pripravené',
    noFiles: 'V tomto katalógu nie je žiadny pripravený súbor ct-rootfs — nahrajte ho zo stránky katalógu',
    source: 'Zdrojový súbor',
    rootfsStorage: 'Úložisko rootfs',
    rootfsStorageHint: "Kde žije rozbalený strom rootfs — úložisko so súborovým systémom a dostatkom voľného miesta na veľkosť po rozbalení plus zhruba 1 GiB rezervy (inak import zlyhá).",
    resources: 'Zdroje',
    cores: 'vCPU',
    memoryMiB: 'Pamäť (MiB)',
    cpuLimit: 'Limit CPU',
    cpuLimitHint: 'Ekvivalenty jadier hostiteľa (napr. 1.5); prázdne = bez stropu',
    cpuUncapped: 'bez stropu',
    cpuWeight: 'Váha CPU',
    hostname: 'Hostname',
    hostnameHint: 'Prázdne = názov CT',
    nameservers: 'Nameservery DNS',
    dnsHint: 'Oddelené čiarkou; prázdne = zdedia sa od hostiteľa',
    searchDomains: 'Vyhľadávacie domény DNS',
    dnsInherited: 'Zdedené od hostiteľa',
    networks: 'Siete',
    nicSlot: 'Slot NIC',
    phase: {
      materializing: 'Materializuje sa',
      ready: 'Pripravená',
      deleting: 'Odstraňuje sa',
      error: 'Chyba'
    },
    exportAction: 'Exportovať do katalógu',
    exportTitle: 'Exportovať do katalógu',
    exportSubmit: 'Exportovať',
    exportError: 'Export bol odmietnutý',
    exportHint: 'Zabalí materializovaný rootfs do NOVÉHO súboru ct-rootfs vo zvolenom katalógu — šablóna zostáva nedotknutá.',
    exportName: 'Názov súboru',
    exportNameHint: 'Prázdne = <template>-export-<n>',
    markCt: {
      action: 'Vrátiť na CT',
      confirmTitle: 'Vrátiť „{name}“ na CT?',
      confirmBody: 'Šablóna opustí tento zoznam a vráti sa do zoznamu CT, znova spustiteľná. Kým ju znova nepovýšite, nemožno z nej vytvárať CT.',
      confirm: 'Vrátiť na CT',
      moved: '„{name}“ je znova CT — nájdete ho v zozname CT.'
    }
  },

  // OCI wave 1 (Annex Q — il modello tag-come-branch): un tag OCI è un branch
  // (puntatore mobile), il digest è il commit; refresh = "git fetch",
  // pull = risolvi ADESSO, scarica QUEL digest.
  oci: {
    registriesTitle: 'Registre OCI',
    imagesTitle: 'Obrazy OCI',
    provider: 'Provider',
    providerDockerhub: 'Docker Hub',
    providerGhcr: 'GHCR',
    providerEcr: 'Amazon ECR',
    providerQuay: 'Red Hat Quay',
    providerGeneric: 'Generický',
    providerImmutableHint: 'Provider je po vytvorení nemenný — iný provider je nový register.',
    url: 'URL',
    urlHintPreset: 'Predvyplnené providerom — prepíšte len pre mirrory.',
    urlHintRequired: 'Povinné pre generické registre: základná URL https://.',
    urlHintEcr: 'Povinné: endpointy ECR sú per-account/per-región — preset neexistuje.',
    credential: 'Poverenie',
    credentialNone: 'Anonymný prístup',
    credentialHint: 'Položka keystore s používateľom a heslom; workery ju rezolvujú v momente použitia — nikdy auth súbory na uzloch.',
    nameHint: 'Názov v štýle hosta (docker.io, registry.intra); jedinečný v scope, nemenný',
    addRegistry: 'Pridať register',
    addRegistryTitle: 'Pridať register OCI',
    verify: 'Overiť',
    verifyState: 'Overenie',
    verified: 'Overený',
    verifyFailed: 'Zlyhalo',
    neverVerified: 'Nikdy neoverený',
    registryInUseError: '„{name}“ má stále registrované repozitáre — najprv ich odstráňte.',
    repositories: 'Repozitáre',
    repositoriesHint: 'Registrácia sleduje branche (tagy OCI) — nič nesťahuje. Aktualizácia rezolvuje každý sledovaný branch a udržiava reflog.',
    noRepositories: 'Na tomto registri nie je registrovaný žiadny repozitár.',
    registerRepository: 'Registrovať repozitár',
    repoPath: 'Cesta',
    repoPathHint: 'Cesta repozitára na registri, napr. „example“ alebo „library/nginx“',
    branches: 'Branche',
    branchesHint: 'Sledované branche (tagy OCI), oddelené čiarkou — napr. 1.1.0, 1.1.1',
    branch: 'Branch',
    branchPullHint: 'Rezolvované TERAZ: pull stiahne digest, na ktorý branch ukazuje dnes.',
    refresh: 'Aktualizovať',
    deleteRepository: 'Odstrániť repozitár',
    reflogCount: 'predchádzajúce: {n}',
    noResolutions: 'Nikdy neaktualizované — žiadna pozorovaná rezolúcia.',
    refreshFailed: 'Posledná aktualizácia zlyhala ({when})',
    loadError: 'Repozitáre sa nepodarilo načítať.',
    reference: 'Referencia',
    digest: 'Digest',
    digestHint: 'sha256:… — presný obraz, bez branchu (detached)',
    size: 'Veľkosť',
    nodes: 'Uzly',
    detached: 'detached',
    detachedHint: 'Stiahnutý podľa digestu, bez branchu — kontrola driftu sa neuplatňuje.',
    pulledAt: 'Stiahnutý',
    pull: 'Pull',
    pullTitle: 'Pull obrazu',
    pullHint: 'Pre-warming, nikdy prerekvizita: pull podľa branchu rezolvuje TERAZ a stiahne TEN digest; pull podľa digestu je detached.',
    pullError: 'Pull bol odmietnutý',
    pullMode: 'Pull podľa',
    pullModeBranch: 'Branch (rezolvovať teraz)',
    pullModeDigest: 'Digest (detached)',
    pullModeBranchHint: 'Poctivé predvolené: ako apt install — spustené neskôr môže dať iný obraz.',
    pullModeDigestHint: 'Presný digest — reprodukovateľnosť a rollback; vzdáva sa kontroly driftu.',

    // Il pattern a due pulsanti (#88, ratifica 2026-07-30 sera): "da
    // registry" è il pull guidato esistente, "da catalogo" materializza un
    // archivio oci-image pronto (la via air-gapped).
    importFromRegistry: 'Importovať z registra',
    importFromCatalog: 'Importovať z katalógu',
    importCatalogTitle: 'Importovať obraz OCI z katalógu',
    importCatalogHint: 'Air-gapped cesta: pripravený archív oci-image (tar/tar.gz — docker-archive alebo oci-archive) sa materializuje do obrazového store s referenciou catalog/<katalóg>/<súbor>@<digest>; aplikácie ho konzumujú ako každý iný obraz. Archívy sa nahrávajú do katalógov — táto sekcia len importuje.',
    importCatalogFile: 'Archív',
    importCatalogFileHint: 'Pripravené súbory oci-image zvoleného katalógu.',
    importCatalogNoFiles: 'V tomto katalógu nie je žiadny pripravený archív oci-image — nahrajte ho z detailu katalógu.',
    importCatalogError: 'Import bol odmietnutý',
    registry: 'Register',
    repository: 'Repozitár',
    cacheMissing: 'Klastrová cache OCI nie je nakonfigurovaná — pully sa odmietajú, kým nenastavíte pool úložiska.',
    setCache: 'Nastaviť cache',
    setCacheTitle: 'Nakonfigurovať cache OCI',
    setCacheHint: 'PREDVOLENÝ pool na úrovni klastra, ktorý hostí bloby stiahnutých obrazov — scope môže urobiť override vlastným poolom (stránka Scope). Zmena sa nedeje za horúca a nič nereštartuje, bloby nepresúva: znova sa lazy objavia pri najbližšom štarte/použití.',
    cachePool: 'Pool úložiska',
    changeCache: 'Zmeniť cache',
    changeCacheTitle: 'Zmeniť pool cache OCI',
    cacheCurrent: 'Cache OCI klastra (predvolená): {name}',
    sectionOverview: 'Prehľad',
    sectionRepositories: 'Repozitáre',
    sectionExplore: 'Prehľadávať',
    exploreHint: 'Živé vzdialené vyhľadávanie na registri — Docker Hub naplno (popis, stiahnutia, hviezdy), ostatné providery best-effort. Vyberte výsledok, prečítajte si jeho úplný popis a prelistujte vzdialené tagy; z tagu môžete pridať referenciu do repozitára TVirt.',
    exploreSearch: 'Hľadať',
    exploreUnsupported: 'Tento provider vyhľadávanie nepodporuje.',
    exploreNoResult: 'Žiadny zodpovedajúci repozitár.',
    exploreNoTags: 'Na tomto repozitári nie je žiadny zodpovedajúci tag.',
    exploreOfficial: 'Oficiálny',
    explorePulls: 'Stiahnutia',
    exploreStars: 'Hviezdy',
    exploreUpdated: 'Aktualizované {when}',
    exploreLoadMore: 'Načítať ďalšie',
    exploreSelectHint: 'Vyberte výsledok: úplný popis a vzdialené tagy sa načítajú sem.',
    exploreNoDescription: 'Od tohto providera nie je k dispozícii žiadny popis.',
    exploreTagsTitle: 'Vzdialené tagy',
    exploreTagFilter: 'Hľadať tag',
    exploreAddToRepo: 'Pridať do repozitára',
    exploreAdded: '{path}:{tag} sa teraz sleduje — pozrite sekciu Repozitáre.',
    addBranch: 'Pridať branch',
    purgeRequiredTitle: 'Odstrániť „{name}“ a jeho obrazy?',
    purgeRequiredBody: 'Žiadna aplikácia tento repozitár nekonzumuje, ale stále existujú stiahnuté obrazy: jeho odstránenie odstráni aj ich záznamy a bloby v cache prejdú garbage collectoru.',
    purgeConfirm: 'Odstrániť aj obrazy',
    providerSelectHint: 'Vyberte typ registra: karta opíše preset a použitie.',
    providerDesc: {
      dockerhub: 'Verejný register Docker: predvyplnená URL, plné vyhľadávanie s popismi a počtami.',
      ghcr: 'GitHub Container Registry: predvyplnená URL; účty používajú personal access token.',
      ecr: 'Amazon Elastic Container Registry: endpointy per-account/per-región — URL treba zadať.',
      quay: 'Register Red Hat Quay: predvyplnená URL.',
      generic: 'Self-hosted register (Harbor, registry:2, …): URL https:// je povinná.'
    },

    // Dialog standard (round #156): i campi del dettaglio immagine/registry
    // che le colonne non mostravano.
    layerCount: 'Layery',
    verifiedAt: 'Posledné overenie',
    verifyOk: 'Výsledok',
    verifyMessage: 'Správa overenia',

    // Model #348/R39: obraz JE digest — obsah — a registry, repozitár a vetva sú MENÁ, ktoré k nemu vedú.
    head: 'Head',
    heads: 'Hlavy podľa architektúry',
    listDigest: 'Digest zoznamu',
    neverResolved: 'Nikdy nerezolvovaný',
    totalSize: 'Celková veľkosť',
    reflogTitle: 'História rezolúcií',
    usedBy: 'Používa ho',
    usageLockfile: 'lockfile',
    usageRunning: 'beží',
    evictable: 'evikovateľný',
    evict: 'Evikcia z cache',
    evictHeadTitle: 'Evikovať {digest}?',
    evictHeadBody: 'Je aktuálnou rezolúciou aspoň jedného kolektora: evikovať ho je legitímne — je to len cache, vzdialený branch ho stále poskytuje — ale nesmie sa to stať omylom. Blob je JEDEN: evikcia vyprázdni všetky kolektory, ktoré ho zdieľajú.',
    evictConfirm: 'Aj tak evikovať',

    arch: 'Architektúra',
    names: 'Mená',
    noNames: 'bez mena',
    views: 'Pohľady',
    lastView: 'posledný pohľad',
    evictLastViewTitle: 'Odstrániť poslednú referenciu na {digest}?',
    evictLastViewBody: 'Toto je posledný pohľad na tento obsah: jeho odstránením obraz prestane v TVirt existovať a bajty ({size}) sa uvoľnia. Je to docker image rm tohto modelu — nie vedľajší účinok, ale samotná operácia.',
    branchesTabHint: 'Sledované vetvy tohto repozitára: pri každej dnešné hlavy — po jednej na architektúru — chronológia obnovení a koľko ňou pomenovaných obrazov je v cache. Obnovenie je «git fetch» repozitára: vyrieši všetky jeho vetvy naraz.',
    noBranches: 'V tomto repozitári sa nesleduje žiadna vetva.',
    stopObserving: 'Prestať sledovať vetvu',
    pullBranch: 'Stiahnuť do cache hlavu branchu (refresh rozlíši, toto sťahuje)',
    pullDigest: 'Stiahnuť do cache tento digest',
    imageCount: 'Obrazy',
    deleteBranchPurgeTitle: 'Ponechať obrazy {name} bez mena?',
    deleteBranchPurgeBody: 'Žiadna aplikácia túto vetvu nepomenúva, ale niektoré obrazy sú dosiahnuteľné len cez ňu: po jej zmazaní zostanú v cache bez mena, vypísané medzi obrazmi repozitára a odstrániteľné ručne.',
    deleteBranchPurgeConfirm: 'Zmazať a ponechať obrazy bez mena',
    imagesTabHint: 'Obrazy tohto repozitára — obsah, teda digesty — viditeľné aj bez výberu vetvy. Obraz je v rámci klastra jedinečný: mien, ktoré k nemu vedú, môže byť viac.',
    noImages: 'Žiadny obraz tohto repozitára nie je v cache materializovaný.',
    deleteRepositoryTitle: 'Zmazať {name}?',
    deleteRepositoryBody: 'Repozitár a jeho vetvy zmiznú aj s chronológiou. Obrazy zostanú v cache: stratia len toto meno. Repozitár, ktorý pomenúva aplikácia, sa zmazať nedá.',
    provenanceCatalog: 'katalóg',
    refreshedAt: 'Obnovené',
    neverRefreshed: 'Nikdy neobnovené',
    sectionBranches: 'Vetvy',
    sectionImages: 'Obrazy',
    repositoriesGovernedElsewhere: 'Tu sa repozitáre iba prezerajú: registrácia, obnovenie, sledovanie vetiev a odstraňovanie obrazov sa robí v sekcii Obrazy OCI.',
    gotoImages: 'Prejsť na Obrazy OCI'
  },

  // Pod nativi (P1): the Pod list — the template's census of instances, the
  // whole-Pod lifecycle, the scale and the delete.
  pods: {
    title: 'Pody',
    containers: 'Kontajnery',
    instances: 'Inštancie',
    instancesTooltip: '{running} beží, {error} v chybe',
    placement: 'Umiestnenie',
    spread: 'rozloženie',
    ha: 'HA',
    templateRevision: 'revízia',
    deleting: 'Odstraňuje sa',
    empty: 'Žiadne pody — vytvorte aplikáciu (jeden kontajner) alebo pod z CLI (create-pod).',
    openInstances: 'Otvoriť inštancie',
    rollingRestart: 'Postupný reštart',
    scale: 'Škálovať',
    scaleTitle: 'Škálovať {name}',
    scaleHint: 'Počet inštancií (0–64): nahor sa obsadí najnižšie voľné poradové číslo, nadol sa odoberie najvyššie a jeho trvalé dáta zostanú.',
    scaleError: 'Škálovanie zlyhalo',
    replicas: 'Repliky',
    deleteRunningError: '{name} beží — najprv ho zastavte.',
    deleteInstancesIntro: 'Všetkých {count} inštancií bude odstránených.',
    stateRunning: 'Beží',
    stateStopped: 'Zastavený',
    editor: {
      createTitle: 'Vytvoriť Pod',
      create: 'Vytvoriť Pod',
      editTitle: 'Upraviť Pod',
      nameHint: 'DNS-1123, najviac 58 znakov — inštancie sa volajú <názov>-<index>; po vytvorení nemenné.',
      restartPolicy: 'Politika reštartu',
      restartPolicyHint_always: 'Uzol reštartuje každý ukončený kontajner s exponenciálnym backoffom (10 s → 5 min).',
      restartPolicyHint_onFailure: 'Reštartuje sa len kontajner ukončený nenulovým kódom; výstup 0 zostáva v pokoji.',
      restartPolicyHint_never: 'Ukončený kontajner zostane, ako je — inštancia skončí ako succeeded alebo failed.',
      grace: 'Odklad (s)',
      graceHint: 'Hranica SIGTERM → SIGKILL zastavenia.',
      hostname: 'Hostname',
      hostnameHint: 'Prázdne = názov inštancie.',
      hostnameDefault: 'názov inštancie',
      sharePid: 'Zdieľať menný priestor PID medzi kontajnermi',
      containersIntro: 'Init kontajnery bežia do konca, po poradí, kým sa kontajnery spustia; kontajnery zdieľajú sieť inštancie (jedna IP, localhost medzi nimi).',
      initContainers: 'Init kontajnery',
      initAdd: 'Pridať init kontajner',
      initHint: 'Každý musí skončiť s 0; zlyhanie uvedie inštanciu do chyby a uzol ho zopakuje s backoffom.',
      containerAdd: 'Pridať kontajner',
      atLeastOne: 'Pod potrebuje aspoň jeden kontajner.',
      duplicateNames: 'Názvy kontajnerov musia byť v Pode jedinečné (vrátane init kontajnerov).',
      containerName: 'Názov kontajnera',
      containerInvalid: 'Tento kontajner je neúplný: názov (DNS-1123), image, pripojenia na deklarované zväzky, číselné limity a sonda.',
      command: 'Príkaz',
      commandHint: 'Prepíše entrypoint image — jeden argument na riadok, nikdy reťazec shellu.',
      args: 'Argumenty',
      argsHint: 'Jeden na riadok (CMD image, ak je prázdne).',
      mounts: 'Pripojenia',
      mountAdd: 'Pridať pripojenie',
      mountNoVolumes: 'Najprv deklarujte zväzok na karte Úložisko.',
      readOnly: 'len na čítanie',
      resources: 'Limity',
      cpus: 'CPU',
      cpusHint: 'podman --cpus (napr. 1.5)',
      memory: 'Pamäť (MiB)',
      memoryHint: 'podman --memory',
      health: 'Sonda živosti',
      healthCmd: 'Príkaz sondy',
      healthCmdHint: 'Spúšťa uzol v kontajneri pri každom tiku dohľadu — jeden argument na riadok; výstup 0 = zdravý.',
      healthTimeout: 'Časový limit (s)',
      healthRetries: 'Pokusy',
      healthRetriesHint: 'Po sebe idúce zlyhania, kým uzol kontajner reštartuje.',
      ips: 'Statické adresy',
      ipsHint: 'Jedna na inštanciu, v poradí ordinálov — škálovanie nad zoznam sa odmietne.',
      instance: 'inštancia',
      volumesHint: 'Zväzky sú Podu; cesta pripojenia patrí každému kontajneru (karta Kontajnery).',
      spread: 'Rozloženie',
      spreadHint_preferred: 'Inštancie na rôznych uzloch, ak je to možné.',
      spreadHint_required: 'Inštancie na rôznych uzloch, inak škálovanie odmietne.',
      spreadHint_none: 'Len rozhodovač.',
      ha: 'Vysoká dostupnosť (opt-in)',
      haHint: 'Každá trvalá časť na zdieľanom úložisku; ak uzol zomrie, HA decider znovu vytvorí inštancie na inom členovi (automatický failover, ako pri HA VM).',
      yes: 'áno',
      no: 'nie'
    },
    detail: {
      container: 'Kontajner',
      actions: 'Akcie',
      ready: 'Pripravený',
      notReady: 'Nepripravený',
      restarts: 'Reštarty',
      lastRestartAt: 'Posledný reštart:',
      backoffUntil: 'Ďalší pokus o',
      stateAbsent: 'chýba',
      stateRunning: 'beží',
      stateTerminated: 'ukončený',
      stateWaiting: 'čaká',
      init: 'init',
      noInstances: 'Žiadne inštancie (repliky 0).',
      ha: 'HA',
      haHint: 'Automatický failover: ak uzol zomrie, HA decider znovu vytvorí inštanciu na inom členovi (každá trvalá časť na zdieľanom úložisku).',
      authority: 'Authority (uzol)',
      homeless: 'bez authority',
      homelessHint: 'Obnova z checkpointu vynechá authority (#380): žiadny uzol ju neobsluhuje, kým Pod neškálujete (stačí aj na rovnaký počet replík).',
      restartContainer: 'Reštartovať len tento kontajner (pod zostáva hore)',
      divergingHint: 'Požadovaný stav tejto inštancie sa líši od predvoleného stavu Podu (PD-P19).',
      revisionLag: 'revízia {applied} použitá z {current}',
      updatedInstances: '{updated}/{desired} inštancií na tejto revízii'
    }
  }
}
